import api from './index';
import Configuration from "../configuration";

import {getEnvironmentVariables} from "../configuration/environment";

export const me = () => {
    return api.get(`/users/me`);
};

export const tokenRequest = ({code}) => {
    return api.post('/auth/token', {
        code: code,
        grant_type: 'authorization_code',
        client_id: Configuration.api.clientId,
        client_secret: '',
        redirect_uri: getEnvironmentVariables().auth.redirectURL,
    });
};

export const registerTerminal = () => {
    return api.post( `/signature-terminals/register`);
};

export const getTerminal = ({identifier}) => {
    return api.get(`/signature-terminals/${identifier}`);
}

export const getSignature = ({identifier}) => {
    return api.get(`/signatures/${identifier}?inlinePdf=true`);
}

export const sign = ({identifier, fileData, marketingOptIn, additionalTermsInitials}) => {
    const body = {fileData, marketingOptIn: !!marketingOptIn};
    // An older Core rejects the field, so send it only when there are terms.
    if (additionalTermsInitials && additionalTermsInitials.length > 0) {
        body.additionalTermsInitials = additionalTermsInitials;
    }
    return api.post(`/signatures/${identifier}/sign`, body);
}

// No expand: Core asks the role for each expanded relation's own permission
// (customer:view, order-note:view) and refuses the whole order when one is
// missing. The saga reports failures itself, so the interceptor stays quiet.
export const getOrder = ({id}) => {
    return api.get(`/orders/${id}`, {quiet: true});
}

// Fetched apart from the order so that a role without customer:view still gets
// the order. A refusal here only means the header goes without the name.
export const getCustomer = ({id}) => {
    return api.get(`/customers/${id}`, {quiet: true});
}

export const orderUpload = ({id, fileData}) => {
    return api.post(`/orders/${id}/upload`, {fileData});
}